module.exports = __webpack_public_path__ + "static/media/logoq-primary2.162e984d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoq-primary2.png
// module id = 585
// module chunks = 0